module.exports = __webpack_public_path__ + "static/media/زيارة بيرن مع مرشد سياحي عربي في سويسرا.82a25032.jpeg";